<template>
  <div class="policy-page">
    <trsShopBreadcrumb
      class="policy-page__breadcrumb"
      :breadcrumbList="breadcrumbList"
      :skip="true"
    />
    <div class="policy-content">
      <section class="policy-section">
        <h3 class="policy-section__heading">1. How long will it take for my order to be dispatched?</h3>
        <p class="policy-text">Orders are typically dispatched within 1–2 business days after payment is confirmed.</p>
        <p class="policy-text">
          If you are located outside the continental United States, including Puerto Rico (PR), Alaska (AK), Hawaii (HI), Guam (GU), AA, AE, or AP regions, please contact us before placing your order.
        </p>
        <p class="policy-text">If your shipping address is a P.O. Box, please contact us in advance.</p>
        <p class="policy-text">
          Contact Email:
          <a href="mailto:sales@tarazon.cn" class="policy-link">sales@tarazon.cn</a>
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">2. How long will shipping take?</h3>
        <p class="policy-text">Shipping from our warehouse typically takes 7-15 business days.</p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">3. Can I track my order?</h3>
        <p class="policy-text">Yes.</p>
        <p class="policy-text">
          Once your order has been shipped, you will find the tracking number on the "TRS Order"-"Logistics Information"
        </p>
        <p class="policy-text">You can use the tracking number to monitor the shipment status online.</p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">4. Can I change my shipping address?</h3>
        <p class="policy-text">Yes, but only before the order has been dispatched.</p>
        <p class="policy-text">
          Please contact us as soon as possible at
          <a href="mailto:sales@tarazon.cn" class="policy-link">sales@tarazon.cn</a>
          if you need to update your shipping address.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import trsShopBreadcrumb from '@/components/layout/shopping/breadcrumb.vue';

export default {
  name: 'trsShippingPolicy',
  mixins: [Mixin],
  components: {
    trsShopBreadcrumb
  },
  data() {
    let v = this;
    return {
      breadcrumbList: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562'),
          path: '/index'
        },
        {
          name: 'SHIPPING POLICY',
          path: '/trsShippingPolicy'
        }
      ]
    };
  },
};
</script>

<style scoped lang="less">
.policy-page {
  width: 1200px;
  margin: 0 auto;
}

.policy-page__breadcrumb {
  margin: 0 auto;
  width: 1200px;
}

.policy-content {
  background-color: #ffffff;
  margin-bottom: 20px;
  padding: 32px 40px 40px;
  color: #333;
  font-family: Arial, 'Microsoft YaHei', sans-serif;
  line-height: 1.8;
}

.policy-section {
  margin-bottom: 0;

  &:last-child {
    margin-bottom: 0;
  }
}

.policy-section__heading {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 700;
  color: #000;
  line-height: 1.5;
}

.policy-text {
  margin: 0 0 12px;
  font-size: 14px;
  color: #333;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
}

.policy-divider {
  margin: 24px 0;
  border: 0;
  border-top: 1px solid #e8e8e8;
}

.policy-link {
  color: #333;
  text-decoration: none;

  &:hover {
    color: #89b92a;
    text-decoration: underline;
  }
}
</style>
